import { useEffect, useState, useRef } from 'react';
import { Gallery } from 'react-grid-gallery';
import Slider from 'react-slick';
import { IMGBASEAPIURL, BASEURL } from '../../../config';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import './gallery.css';

const GalleryMain = () => {
  const sliderRef = useRef();

  const settings = {
    autoplay: false,
    arrows: true,
    dots: false,
    slidesToShow: 13,
    slidesToScroll: 5,
    responsive: [
      { breakpoint: 768, settings: { slidesToShow: 7, slidesToScroll: 3 } },
      { breakpoint: 480, settings: { slidesToShow: 4, slidesToScroll: 2 } },
    ],
  };

  const [Show, setShow] = useState(false);
  const [Index, setIndex] = useState(0);

  const [ShowImage] = useState(
    Array.from({ length: 25 }, (_, i) => ({
      src: `https://picsum.photos/800/600?random=${i + 1}`,
      thumbnail: `https://picsum.photos/400/300?random=${i + 1}`,
      caption: `Sample Image ${i + 1}`,
    }))
  );

  function handleClick(index, item) {
    setIndex(index);
    setShow(true);
  }

  return (
    <>
      <section
        className="corporate-learning"
        data-overlay="6"
        style={{
          backgroundImage: `url(${IMGBASEAPIURL}institute/contactus/gallery.jpg)`,
          backgroundPosition: 'center',
          padding: '70px 10px',
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12 text-center">
              <h1 className="mt-3 text-white mb-1">Gallery</h1>
              <p className="mb-3">Dream | Learn | Do</p>
            </div>
          </div>
        </div>
      </section>

      {Show && (
        <div className="imagePopUPBox">
          <h3 className="imagePopUPClose" onClick={() => setShow(false)}>X</h3>
          <div className="imagePopUPIndex">
            <b>{ShowImage[Index].caption}</b><br />
            {Index + 1}/{ShowImage.length}
          </div>
          <img
            className="imagePopUP"
            src={ShowImage[Index].src}
            alt={ShowImage[Index].caption}
          />
          <div className="imagePopUPSlider">
            <Slider ref={sliderRef} {...settings}>
              {ShowImage.map((cti, i) => (
                <div key={cti.src} title={cti.caption} onClick={() => setIndex(i)}>
                  <div className="appie-features-content">
                    <img src={cti.thumbnail} alt={cti.caption} />
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      )}

      <section className="galleryBlock p-0">
        <div className="container-fluid bg-dark">
          {ShowImage.length > 0 ? (
            <Gallery
              images={ShowImage}
              onClick={handleClick}
              enableImageSelection={false}
            />
          ) : (
            <center>
              <img
                className="m-5"
                width="50px"
                height="50px"
                src={`${BASEURL}/loader.gif`}
                alt="Loading..."
              />
            </center>
          )}
        </div>
      </section>
    </>
  );
};

export default GalleryMain;
